export const GlobalAuditlogListSuccess = 'GLOBAL_LIST_SUCCESS';

export function setGlobalAuditlogListAction(data) {
  return {
    type: GlobalAuditlogListSuccess,
    payload: data,
  };
}
